import {call, put} from '@redux-saga/core/effects';
import {actions as homeActions} from './action';
import {REGION} from '../../../common/constant';
import callApi, {callApiList} from '../../../common/util/api';
import {typedSelect} from '../../../common/util/saga';
import {actions as mainActions} from '../../main/state/action';
import {
  getTodayFreeSeries,
  getMain,
  getRanking,
  getRecommendContentCards,
  getSpecialList,
  getWufPlus,
  getWaitfreeContentList,
} from '../../main/state/apiGet';
import {actions as timeTableActions} from '../../timeTable/state/action';
import {getCompletedGenres} from '../../timeTable/state/apiGet';
import {
  MAIN_HOT_TAB,
  MAIN_WAITFREE_TAB,
  MAIN_TODAY_FREE_SERIES_TAB,
} from '../common';
import {HomeTabPage} from '../type';

export function* fetchCompletedGenres() {
  const {success, data} = yield call(callApi, {
    url: '/section/v1/compact-sections',
    params: {tag: 'timetable_finish_genre'},
  });
  if (success && data) {
    yield put(timeTableActions.setCompletedGenres(getCompletedGenres(data)));
  }
}

export function* fetchRecommendList() {
  const {success, data} = yield call(callApi, {
    url: '/section/v4/sections',
    params: {placement: 'main_featured'},
  });
  if (success && data) {
    yield put(
      mainActions.setMainContents({
        recommends: getRecommendContentCards(data),
      })
    );
  }
}

export function* fetchSpecialList() {
  const {success, data} = yield call(callApi, {
    url: '/section/v4/sections',
    params: {placement: 'main_special'},
  });
  if (success && data) {
    yield put(mainActions.setMainContents({specials: getSpecialList(data)}));
  }
}

export function* fetchWaitfreeList() {
  const {success, data} = yield call(callApi, {
    url: '/section/v4/sections',
    params: {placement: 'main_gidamoo'},
  });
  if (success && data) {
    yield put(
      mainActions.setMainContents({waitfrees: getWaitfreeContentList(data)})
    );
  }
}

export function* fetchMainList() {
  const isKorea = REGION === 'kor';
  const apiList = [
    {
      url: '/section/v1/view/bundles',
      params: {tag: 'top_featured'},
    },
    {
      url: '/section/v1/web-configurations/rank',
    },
    {
      url: '/section/v1/web-configurations/top-rank',
    },
  ];

  // TODO : master브랜치에 머지시 master-global에서 작업한 wuf api도 아래와 같은 양식으로 통일한다.
  const todayFreeSeriesApi = {
    url: '/section/v1/view/bundles',
    params: {tag: 'top_free_publishing'},
  };

  const wufApi = {
    url: '/section/v1/view/bundles',
    params: {tag: 'top_gidamoo_plus'},
  };

  if (isKorea) {
    apiList.push(todayFreeSeriesApi);
  } else {
    apiList.push(wufApi);
  }

  const {success, data} = yield call(callApiList, apiList);

  if (success && data) {
    const [hotData, rankData, topRankData, secondTabData] = data;
    const selectedMainSecondTab = yield* typedSelect(
      state => state.home.secondTabs[HomeTabPage.Main].selected
    );

    const rankingResult = getRanking(rankData, topRankData);
    const newTabList = rankingResult.tabs.map(item => ({
      key: item.id,
      text: item.title,
    }));

    yield put(
      homeActions.setPropertyValues('secondTabs', {
        [HomeTabPage.Main]: {
          selected: selectedMainSecondTab,
          tabList: isKorea
            ? [MAIN_HOT_TAB, MAIN_TODAY_FREE_SERIES_TAB, ...newTabList]
            : [MAIN_HOT_TAB, MAIN_WAITFREE_TAB, ...newTabList],
        },
      })
    );
    yield put(mainActions.setValue('ranking', rankingResult));
    yield put(mainActions.setValue('hotList', getMain(hotData)));

    if (isKorea) {
      yield put(
        mainActions.setValue(
          'todayFreeSeries',
          getTodayFreeSeries(secondTabData)
        )
      );
    } else {
      yield put(mainActions.setValue('wufPlus', getWufPlus(secondTabData)));
    }
  }
}
